"use strict";
import { tns } from "tiny-slider";

export default function () {
    const valid = document.querySelector(".o-cases__list");
    if (valid) {
        const slider = tns({
            container: ".o-cases__list",
            slideBy: 1,
            controls: false,
            nav: false,
            gutter: 12,
            loop: true,
            items: 1.3,
            touch: true,
            mouseDrag: true,
            responsive: {
                1024: {
                    items: 3,
                },

                1100: {
                    items: 4,
                },
            },
        });

        const arrowLeft = document.querySelector(".o-cases .arrows-left");
        arrowLeft.addEventListener("click", () => {
            slider.goTo("prev");
        });
        const arrowRight = document.querySelector(".o-cases .arrows-right");
        arrowRight.addEventListener("click", () => {
            slider.goTo("next");
        });
    }
}
